import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api/menuitem';
import { ScrollPanel } from 'primeng/scrollpanel';
import { AppConsts } from 'src/shared/AppConsts';
import { AppComponentBase } from './app-component-base';
import { AppComponent } from './app.component';
import { AcercaDeComponent } from './admin/acercade/acercade.component';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent extends AppComponentBase implements OnInit, AfterViewInit {

    @ViewChild('layoutMenuScroller', { static: false }) layoutMenuScrollerViewChild: ScrollPanel;

    @Input() reset: boolean;

    model: any[];

    constructor(
        injector: Injector,
        public app: AppComponent) {
        super(injector);
    }

    ngOnInit() {
        const self = this;

        this.model = [
            { label: this.l('Dashboard'), icon: 'pi pi-chart-bar', routerLink: ['/app/main/dashboard'] },
            {
                label: this.l('Instances'),
                icon: 'fa fa-th',
                routerLink: ['/app/admin/tenant'],
                permissionName: 'Pages.Tenants',
                visible: AppConsts.isHost
            },
            {
                label: this.l('Administration'), icon: 'pi pi-briefcase',
                items: [
                    {
                        label: this.l('Roles'),
                        icon: 'pi pi-list',
                        routerLink: ['/app/admin/roles'],
                        permissionName: 'Pages.Administration.Roles',
                        visible: AppConsts.isHost
                    },
                    {
                        label: this.l('Languages'),
                        icon: 'pi pi-comment',
                        routerLink: ['/app/admin/languages'],
                        permissionName: 'Pages.Administration.Languages'
                    },
                    {
                        label: this.l('Users'),
                        icon: 'pi pi-users',
                        routerLink: ['/app/admin/users'],
                        permissionName: 'Pages.Administration.Users',
                        visible: AppConsts.isHost
                    },
                    {
                        label: this.l('OrgUnits'),
                        icon: 'pi pi-sitemap',
                        routerLink: ['/app/admin/orgunits'],
                        permissionName: 'Pages.Administration.OrgUnits',
                        visible: false
                    },
                    {
                        label: this.l('AuditLogs'),
                        icon: 'pi pi-lock',
                        routerLink: ['/app/admin/auditLogs'],
                        permissionName: 'Pages.Administration.AuditLogs'
                    },
                    {
                        label: this.l('Maintenance'),
                        icon: 'fa fa-fw fa-wrench',
                        routerLink: ['/app/admin/maintenance'],
                        permissionName: 'Pages.Administration.Host.Maintenance',
                        visible: !(AppConsts.multiTenancy && AppConsts.tenancyName)
                    },
                    {
                        label: this.l('Host.Settings'),
                        icon: 'pi pi-cog',
                        routerLink: ['/app/admin/host/settings'],
                        permissionName: 'Pages.Administration.Host.Settings',
                        visible: AppConsts.isHost
                    },
                    // {
                    //    label: this.l('Tenant.Settings'),
                    //    icon: 'pi pi-cog',
                    //    routerLink: ['/app/admin/tenants/settings'],
                    //    permissionName: 'Pages.Administration.Tenant.Settings'
                    // },
                    {
                        label: this.l('EmailGroups'),
                        icon: 'pi pi-envelope',
                        routerLink: ['/app/admin/emailgroups'],
                        permissionName: 'conftcor.0'
                    },
                    {
                        label: this.l('ChatRooms'),
                        icon: 'pi pi-comments',
                        routerLink: ['/app/admin/chatrooms'],
                        permissionName: 'Pages.Administration.ChatRooms',
                        visible: false
                    },
                    {
                        label: this.l('Helps'),
                        icon: 'pi pi-question',
                        routerLink: ['/app/admin/helps'],
                        permissionName: 'Pages.Administration.Helps',
                        visible: AppConsts.isHost
                    },
                    {
                        label: this.l('Sessions'),
                        icon: 'pi pi-users',
                        routerLink: ['/app/admin/sessions'],
                        permissionName: 'Pages.Administration.Tenant.Sessions'
                    }
                ]
            },
            self.getMenuUnits(),
            self.getMenuCatalogos(),
            self.getMenuConfiguracionesHospital(),
            self.getMenuProcesos(),
            self.getMenuSesiones(),
            {
                label: this.l('Procesos.MensajesHL7'),
                icon: 'pi pi-send',
                routerLink: ['/app/procesos/mensajeshl7'],
                permissionName: 'Procesos.MensajesHL7'
            },
            self.getReportsMenu(),
            self.getReportesInternosMenu(),
            {
                label: this.l('Helps.Global'),
                icon: 'pi pi-question',
                routerLink: ['/app/admin/helps/global'],
                permissionName: 'Pages.Administration.Helps.Global'
            },
            {
                label: 'Acerca de SAIR',
                icon: 'pi pi-at',
                command: () => {
                    self.mostrarAcercaDe();
                },

            }
        ];
    }

    mostrarAcercaDe(): void {
        const self = this;

        const ref = self.dialogService.open(AcercaDeComponent, {
            styleClass: 'd-sm d-md-50 d-lg-40 d-xl-40',
            // header: self.l('Procesos.SesionesHD.Sesion.Medicaciones.Agregar.Titulo'),
            showHeader: false,
            dismissableMask: false
        });
    }

    getMenuUnits(): any {
        const self = this;

        return {
            label: this.l('Units'),
            icon: 'pi pi-table',
            visible: AppConsts.isHost,
            items: [
                {
                    label: this.l('Units.Roles'),
                    icon: 'pi pi-list',
                    routerLink: ['/app/admin/unitsroles'],
                    permissionName: 'Units.Roles',
                    visible: AppConsts.isHost
                },
                {
                    label: this.l('Units.Users'),
                    icon: 'pi pi-users',
                    routerLink: ['/app/admin/unitsusers'],
                    permissionName: 'Units.Users',
                    visible: AppConsts.isHost
                },
                {
                    label: this.l('Tenant.Settings'),
                    icon: 'pi pi-cog',
                    routerLink: ['/app/admin/tenants/settings'],
                    permissionName: 'Units.Settings',
                    visible: AppConsts.isHost
                }
            ]
        };
    }

    getMenuCatalogos(): any {
        const self = this;

        return {
            label: this.l('Catalogos'),
            icon: 'pi pi-table',
            items: [
                {
                    label: this.l('Catalogos.Parametros'),
                    icon: 'pi pi-table',
                    routerLink: ['/app/catalogs/parametros'],
                    permissionName: 'Catalogos.Parametros'
                },
                {
                    label: this.l('Catalogos.Generales'),
                    icon: 'pi pi-table',
                    routerLink: ['/app/catalogs/generales'],
                    permissionName: 'Catalogos.Generales',
                    visible: AppConsts.isHost
                },
                {
                    label: this.l('Catalogos.Hospitales'),
                    icon: 'pi pi-table',
                    routerLink: ['/app/catalogs/hospitales'],
                    permissionName: 'Catalogos.Hospitales',
                    visible: AppConsts.isHost
                },
                {
                    label: this.l('Catalogos.PruebasEstudios'),
                    icon: 'pi pi-table',
                    routerLink: ['/app/catalogs/pruebasestudios'],
                    permissionName: 'Catalogos.PruebasEstudios',
                    visible: AppConsts.isHost
                },
                {
                    label: this.l('Catalogos.ServiciosHospitales'),
                    icon: 'pi pi-table',
                    routerLink: ['/app/catalogs/servicioshospitales'],
                    permissionName: 'Catalogos.ServiciosHospitales',
                    visible: !AppConsts.isHost
                },
                {
                    label: this.l('Catalogos.SalasHemodialisis'),
                    icon: 'pi pi-table',
                    routerLink: ['/app/catalogs/salas'],
                    permissionName: 'Catalogos.Salas',
                    visible: !AppConsts.isHost
                },
                {
                    label: this.l('Catalogos.Maquinas'),
                    icon: 'pi pi-table',
                    routerLink: ['/app/catalogs/maquinas'],
                    permissionName: 'Catalogos.Maquinas',
                    visible: !AppConsts.isHost
                },
                // {
                //    label: this.l('Catalogos.Turnos'),
                //    icon: 'pi pi-table',
                //    routerLink: ['/app/catalogs/turnos'],
                //    permissionName: 'Catalogos.Turnos',
                //    visible: !AppConsts.isHost
                // },
                {
                    label: this.l('Catalogos.Patients'),
                    icon: 'pi pi-table',
                    routerLink: ['/app/catalogs/patients'],
                    permissionName: 'Catalogos.Patients',
                    visible: !AppConsts.isHost
                },
            ]
        };
    }

    getMenuConfiguracionesHospital(): any {
        const self = this;

        return {
            label: this.l('Procesos.ConfiguracionHospital.Menu'),
            icon: 'fa fa-cogs',
            items: [
                {
                    label: this.l('Procesos.ConfiguracionHospital'),
                    icon: 'pi pi-cog',
                    routerLink: ['/app/procesos/configurarhospital'],
                    permissionName: 'Procesos.ConfiguracionHospital'
                },
                {
                    label: this.l('Procesos.MedicosUnidades'),
                    icon: 'pi pi-user',
                    routerLink: ['/app/procesos/medicounidad'],
                    permissionName: 'Procesos.MedicoUnidad'
                },
                {
                    label: this.l('Procesos.TurnosHospitales'),
                    icon: 'pi pi-table',
                    routerLink: ['/app/procesos/turnoshospital'],
                    permissionName: 'Procesos.TurnosHospitales'
                },
                {
                    label: this.l('Procesos.ControlEstatusMaquina'),
                    icon: 'pi pi-star',
                    routerLink: ['/app/procesos/estatusmaquinas'],
                    permissionName: 'Procesos.ControlEstatusMaquinas'
                }
            ]
        };
    }

    getMenuProcesos(): any {
        const self = this;

        return {
            label: this.l('Procesos'),
            icon: 'pi pi-clone',
            items: [
                {
                    label: this.l('Procesos.ControlEstatus'),
                    icon: 'pi pi-verified',
                    routerLink: ['/app/procesos/controlestatus'],
                    permissionName: 'Procesos.ControlEstatus'
                },
                {
                    label: this.l('Procesos.AccesosVasculares'),
                    icon: 'pi pi-sync',
                    routerLink: ['/app/procesos/accesosvasculares'],
                    permissionName: 'Procesos.AccesosVasculares'
                },
                {
                    label: this.l('Procesos.PrescripcionHD'),
                    icon: 'pi pi-check-square',
                    routerLink: ['/app/procesos/prescripcionhd'],
                    permissionName: 'Procesos.PrescripcionesHD'
                },
                {
                    label: this.l('Procesos.EstudiosPacientes'),
                    icon: 'pi pi-file',
                    routerLink: ['/app/procesos/registrospruebas'],
                    permissionName: 'Procesos.EstudiosPacientes'
                },
                {
                    label: this.l('Procesos.EstudiosPacientes.Importar.Menu'),
                    icon: 'pi pi-file',
                    routerLink: ['/app/procesos/registrospruebas/importar'],
                    permissionName: 'Procesos.EstudiosPacientes.Import',
                    visible: AppConsts.isHost
                }
            ]
        };
    }

    getMenuSesiones(): any {
        const self = this;

        return {
            label: this.l('Procesos.SesionesHD'),
            icon: 'pi pi-chart-line',
            items: [
                {
                    label: this.l('Procesos.SesionesHD.Menu'),
                    icon: 'pi pi-calendar',
                    routerLink: ['/app/procesos/citas'],
                    permissionName: 'Procesos.SesionesHD'
                },
                {
                    label: this.l('Procesos.SesionesHD.Sesion.Busqueda.Titulo'),
                    icon: 'pi pi-table',
                    routerLink: ['/app/procesos/sesioneshd'],
                    permissionName: 'Procesos.SesionesHD'
                }
            ]
        };
    }

    getReportsMenu(): any {
        const self = this;
        const items = [];

        items.push({
            label: this.l('Reportes.InformeIngresos'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/informeingresos'],
            permissionName: 'Pages.Reportes.InformeIngresos'
        });

        items.push({
            label: this.l('Reportes.InformeEgresos'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/informeegresos'],
            permissionName: 'Pages.Reportes.InformeEgresos'
        });

        items.push({
            label: this.l('Reportes.InformeSesionesProgramadas'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/informesesionesprogramadas'],
            permissionName: 'Pages.Reportes.InformeSesionesProgramadas',
            visible: !AppConsts.isHost
        });

        items.push({
            label: this.l('Reportes.RelacionPacientesServicioHD'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/relacionpacientesserviciohd'],
            permissionName: 'Pages.Reportes.RelacionPacientesServicioHD'
        });

        items.push({
            label: this.l('Reportes.InformeSesionesEfectOtorgPaciente'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/informesesionesefectotorgpaciente'],
            permissionName: 'Pages.Reportes.InformeSesionesEfectOtorgPaciente'
        });

        items.push({
            label: this.l('Reportes.EstadisticosUnidadHD'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/estadisticosunidadhd'],
            permissionName: 'Pages.Reportes.EstadisticosUnidadHD'
        });

        items.push({
            label: this.l('Reportes.ResumenClinico'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/resumenclinico'],
            permissionName: 'Pages.Reportes.ResumenClinico',
            visible: !AppConsts.isHost
        });

        items.push({
            label: this.l('Reportes.NotaInicial'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/notainicial'],
            permissionName: 'Pages.Reportes.NotaInicial',
            visible: !AppConsts.isHost
        });

        items.push({
            label: this.l('Reportes.HistoriaClinica'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/historiaclinica'],
            permissionName: 'Pages.Reportes.HistoriaClinica',
            visible: !AppConsts.isHost
        });

        items.push({
            label: this.l('Procesos.EvolucionMedica'),
            icon: 'pi pi-list',
            routerLink: ['/app/procesos/evolucionmedica'],
            permissionName: 'Procesos.EvolucionMedica',
            visible: !AppConsts.isHost
        });

        return {
            label: self.l('Reportes'),
            icon: 'pi pi-list',
            items: items,
            permissionName: 'Pages.Reportes'
        };
    }

    getReportesInternosMenu(): any {
        const self = this;
        const items = [];

        items.push({
            label: this.l('Reportes.Internos.SesionesOtorgadas'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/sesionesotorgadas'],
            permissionName: 'Pages.Reportes.Internos.SesionesOtorgadas'
        });

        items.push({
            label: this.l('Reportes.Internos.SesionesAbiertas'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/sesionesabiertas'],
            permissionName: 'Pages.Reportes.Internos.SesionesAbiertas'
        });

        items.push({
            label: this.l('Reportes.Internos.SesionesEliminadas'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/sesioneseliminadas'],
            permissionName: 'Pages.Reportes.Internos.SesionesEliminadas'
        });

        items.push({
            label: this.l('Reportes.Internos.SesionesSuspendidas'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/sesionessuspendidas'],
            permissionName: 'Pages.Reportes.Internos.SesionesSuspendidas'
        });

        items.push({
            label: this.l('Reportes.Internos.DetalleSesiones'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/detallesesiones'],
            permissionName: 'Pages.Reportes.Internos.DetalleSesiones'
        });

        items.push({
            label: this.l('Reportes.Internos.SesionesMensajesHL7'),
            icon: 'pi pi-list',
            routerLink: ['/app/reports/sesionesmensajeshl7'],
            permissionName: 'Pages.Reportes.Internos.SesionesMensajesHL7'
        });

        return {
            label: self.l('Reportes.Internos'),
            icon: 'pi pi-list',
            items: items,
            permissionName: 'Pages.Reportes.Internos'
        };
    }


    ngAfterViewInit() {
        setTimeout(() => {
            this.layoutMenuScrollerViewChild.moveBar();
        }, 100);
    }

    onMenuClick(event) {
        if (!this.app.isHorizontal()) {
            setTimeout(() => {
                this.layoutMenuScrollerViewChild.moveBar();
            }, 450);
        }
        this.app.onMenuClick(event);
    }
}

@Component({
    /* eslint-disable @angular-eslint/component-selector */
    selector: '[app-submenu]',
    /* eslint-enable @angular-eslint/component-selector */
    template: `
        <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
            <li *ngIf="showMenuItem(child)" [ngClass]="{'active-menuitem': isActive(i)}" [class]="child.badgeStyleClass">
                <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" (mouseenter)="onMouseEnter(i)"
                   *ngIf="!child.routerLink" [ngClass]="child.styleClass"
                   [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target">
                    <i [ngClass]="child.icon" class="layout-menuitem-icon"></i>
                    <span class="layout-menuitem-text">{{child.label}}</span>
                    <i class="fa fa-fw fa-angle-down layout-submenu-toggler" *ngIf="child.items"></i>
                    <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                </a>
                <a (click)="itemClick($event,child,i)" (mouseenter)="onMouseEnter(i)" *ngIf="child.routerLink"
                   [routerLink]="child.routerLink" routerLinkActive="active-menuitem-routerlink" [fragment]="child.fragment"
                   [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target">
                    <i [ngClass]="child.icon" class="layout-menuitem-icon"></i>
                    <span class="layout-menuitem-text">{{child.label}}</span>
                    <i class="fa fa-fw fa-angle-down layout-submenu-toggler" *ngIf="child.items"></i>
                    <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                </a>
                <div class="layout-menu-tooltip">
                    <div class="layout-menu-tooltip-arrow"></div>
                    <div class="layout-menu-tooltip-text">{{child.label}}</div>
                </div>
                <ul app-submenu [item]="child" *ngIf="child.items" [visible]="isActive(i)" [reset]="reset" [parentActive]="isActive(i)"
                    [@children]="(app.isSlim()||app.isHorizontal())&&root ? isActive(i) ?
                    'visible' : 'hidden' : isActive(i) ? 'visibleAnimated' : 'hiddenAnimated'"></ul>
            </li>
        </ng-template>
    `,
    animations: [
        trigger('children', [
            state('hiddenAnimated', style({
                height: '0px'
            })),
            state('visibleAnimated', style({
                height: '*'
            })),
            state('visible', style({
                height: '*',
                'z-index': 100
            })),
            state('hidden', style({
                height: '0px',
                'z-index': '*'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppSubMenuComponent extends AppComponentBase {
    @Input() item: MenuItem;
    @Input() root: boolean;
    @Input() visible: boolean;

    _parentActive: boolean;
    _reset: boolean;
    activeIndex: number;

    constructor(injector: Injector, public app: AppComponent, public appMenu: AppMenuComponent, public router: Router) {
        super(injector);
    }

    @Input() get reset(): boolean {
        return this._reset;
    }

    @Input() get parentActive(): boolean {
        return this._parentActive;
    }

    set reset(val: boolean) {
        this._reset = val;
        if (this._reset && (this.app.isHorizontal() || this.app.isSlim())) {
            this.activeIndex = null;
        }
    }

    set parentActive(val: boolean) {
        this._parentActive = val;

        if (!this._parentActive) {
            this.activeIndex = null;
        }
    }

    itemClick(event: Event, item: MenuItem, index: number) {
        if (this.root) {
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }
        // avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }
        // activate current item and deactivate active sibling if any
        this.activeIndex = (this.activeIndex === index) ? null : index;
        // execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
        }
        // prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            setTimeout(() => {
                this.appMenu.layoutMenuScrollerViewChild.moveBar();
            }, 450);
            event.preventDefault();
        }

        // hide menu
        if (!item.items) {
            if (this.app.isHorizontal() || this.app.isSlim()) {
                this.app.resetMenu = true;
            } else {
                this.app.resetMenu = false;
            }
            this.app.overlayMenuActive = false;
            this.app.staticMenuMobileActive = false;
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }

        if (item['reloadAlways']) {
            this.app.redirectTo(item.routerLink);
        }
    }

    onMouseEnter(index: number) {
        if (this.root && this.app.menuHoverActive && (this.app.isHorizontal() || this.app.isSlim())
            && !this.app.isMobile() && !this.app.isTablet()) {
            this.activeIndex = index;
        }
    }

    isActive(index: number): boolean {
        return this.activeIndex === index;
    }

    showMenuItem(menuItem): boolean {

        if (menuItem.visible === false) {
            return false;
        }

        if (menuItem.permissionName) {
            return this.permission.isGranted(menuItem.permissionName);
        }

        if (menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return true;
    }

    checkChildMenuItemPermission(menuItem): boolean {

        for (const subMenuItem of menuItem.items) {
            if (subMenuItem.permissionName && this.permission.isGranted(subMenuItem.permissionName) && subMenuItem.visible !== false) {
                return true;
            }

            if (subMenuItem.items && subMenuItem.items.length) {
                return this.checkChildMenuItemPermission(subMenuItem);
            } else if (!subMenuItem.permissionName) {
                return true;
            }
        }

        return false;
    }
}
